import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { __ } from '../../core/utils';
import styles from '../../styles/forms/create_folder_wizard/CreateFolderForm.scss';

const CreateFolderForm = ({
  handleSubmit,
  onClose,
  submitting,
  submitLabel,
}) => {
  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <Field name='title' component={Input} label={__('Folder name')} />
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={onClose}
        />
        <Button
          lightBlue
          medium
          middleText={submitLabel || __('button.add')}
          spinning={submitting}
          onClick={handleSubmit}
        />
      </div>
    </Form>
  );
};

export default reduxForm({
  form: 'create_folder_wizard.create_folder',
  enableReinitialize: true,
})(CreateFolderForm);
